import React from 'react';
import { Box, IconButton, Toolbar } from '@material-ui/core';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import { pickBy } from 'lodash/fp';
import { useHistory } from 'react-router-dom';
import { Filters, LIMIT, LoadMoreComponent, useFilter } from '../../../shared';
import { useDebounce } from '../../../../utils';
import { FixedBox, SecondaryToolbar } from '../../../../ui-kit';
import { GET_BILLS } from '../../graphql';
import { DateFromTo, QueryBillsArgs } from '../../../../generated/graphql';
import { getUrlParams } from '../../../../utils/helpers/urlParams';
import MoreFilters from './MoreFilters';

const initialState = {
    place: '',
    openedBy: '',
    name: '',
    date: { from: undefined, to: undefined },
    moreFilters: {
        cash: false,
        card: false,
        reported: false,
        notReported: false,
        voidedOnly: false,
        discountedOnly: false,
    },
};

const Bills = () => {
    const history = useHistory();
    const [discountedOnlyParam, voidedOnlyParam] = getUrlParams({ searchString: history.location.search, params: ['discounted', 'voided'] });
    const { formData, handleChange, setFormData } = useFilter({
        ...initialState,
        moreFilters: {
            ...initialState.moreFilters,
            discountedOnly: !!discountedOnlyParam,
            voidedOnly: !!voidedOnlyParam,
        },
    });
    const resetFilters = () => setFormData(initialState);
    const variables = useDebounce(formData);

    const { moreFilters, date, name, ...otherFilters } = variables;

    let finalDate: DateFromTo | undefined;

    if (date.from !== undefined && date.to !== undefined) {
        finalDate = {
            ...date as unknown as DateFromTo
        };
    }
    const finalFilters = {
        moreFilters,
        date: finalDate,
        billNumber: name || undefined,
        ...pickBy(a => a !== '', otherFilters)
    };

    const queryVariables: QueryBillsArgs = {
        filters: finalFilters,
        offset: 0,
        limit: LIMIT,
    };

    return (
        <>
            <Toolbar />
            <FixedBox>
                <SecondaryToolbar>
                    <Filters formData={formData} handleChange={handleChange} setFormData={setFormData}>
                        <MoreFilters formData={formData} setFormData={setFormData} />
                        <IconButton onClick={resetFilters}>
                            <RotateLeftIcon color='primary' />
                        </IconButton>
                    </Filters>
                </SecondaryToolbar>
            </FixedBox>
            <Box mx={7} my={3} alignContent='center' display='flex' alignItems='start' flexGrow={1}>
                <LoadMoreComponent queryArgs={queryVariables} query={GET_BILLS} />
            </Box>
        </>
    );
};

export default Bills;
